import { Checkbox, Modal, Table } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import rpmService from "../../../../../Services/rpmService";
import { fetchRpmTasksList } from "../../../../../Redux/actions/rpmActions";

function TasksListTable({ data, currentPage, totalPages, setCurrentPage }) {
  const [actInactiveMod, setActInactiveMod] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code ? a.code.localeCompare(b.code) : ""),
      render: (text) => <div style={{ textWrap: "balance" }}>{text}</div>,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : ""),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) =>
        a.description ? a.description.localeCompare(b.description) : "",
      render: (text) => <div style={{ textWrap: "balance" }}>{text}</div>,
    },
    {
      title: "Active/Inactive",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <Checkbox className="checkbox-green" checked={record.status === 1} />
      ),
    },
  ];

  const handleTaskActInactive = async () => {
    setLoader(true);
    const payload = {
      ...selectedTask,
      id: selectedTask.id,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      status: 0,
    };
    try {
      await rpmService.taskActiveInactive(payload);
      handleStatusChange(null, "close");
      setLoader(false);
      dispatch(fetchRpmTasksList({ status: 1 }));
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handleStatusChange = (device, action) => {
    if (action === "open") {
      setActInactiveMod(true);
      setSelectedTask(device);
    } else if (action === "close") {
      setActInactiveMod(false);
      setSelectedTask(null);
    }
  };

  return (
    <>
      <div>
        <div
          className={`min-w-full ${data ? "w-max" : "flex-1"
            } rounded-lg flex justify-center py-2`}
        >
          <table className={`w-full mx-2 overflow-scroll relative`}>
            <thead className="sticky top-0 bg-white z-10">
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Description</th>
                <th>Active/Inactive</th>
              </tr>
              <tr className="bg-[#DEF3F2]">
                <td className="py-0.5" colSpan={12}></td>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={idx}>
                  <tr>
                    <td>
                      <div style={{ textWrap: "balance" }}>{item.code}</div>
                    </td>
                    <td>{item.name}</td>
                    <td>
                      <div style={{ textWrap: "balance" }}>
                        {item.description}
                      </div>
                    </td>
                    <td>
                      <Checkbox
                        className="checkbox-green"
                        checked={item.status === 1}
                        onClick={() => handleStatusChange(item, "open")}
                      />
                    </td>
                  </tr>
                  <tr className="bg-[#DEF3F2]">
                    <td className="py-0.5" colSpan={12}></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Optional Pagination */}
        {/* <div className="absolute -bottom-32 right-8 flex justify-end my-2">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                        containerClassName="mb-4"
                        buttonClassName="border border-gray-300 md:px-3 px-2 rounded-full md:py-1 py-0.5 transition duration-300 ease-in-out focus:outline-none hover:bg-[#787878]"
                        activeButtonClassName="bg-brand-primaryColor rounded-full text-white"
                    />
                </div> */}
      </div>

      {/* Active/ Inactive confirmation modal */}
      <Modal
        open={actInactiveMod}
        onCancel={() => handleStatusChange(null, "close")}
        footer={[]}
        destroyOnClose
        title="Confirmation"
      >
        <div>
          <p>Are you sure you want to change the status</p>
          <div className="w-full flex justify-end items-center mt-3">
            <button
              onClick={() => handleStatusChange(null, "close")}
              className="mx-1 p-1 w-24 border rounded-md bg-white border"
            >
              Cancel
            </button>
            <button
              disabled={loader}
              onClick={handleTaskActInactive}
              className="mx-1 p-1 w-24 font-semibold bg- text-white rounded-md disabled:cursor-not-allowed disabled:opacity-50"
            >
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default TasksListTable;
